import AccessPointShippingForm from '_core_ext/components/checkout/shipping/shippingForms/AccessPoint';
export default class DHLShippingForm extends AccessPointShippingForm {
    init() {
        super.init();
        this.settings = {};
        this.initConfig(this.settings);
    }
}